import type { IUrlStore } from "../../application/interfaces/IUrlStore";
export class LocalStorageUrlStore implements IUrlStore{
    readonly afterLoginName = "tsm_goto_after_login";

    async saveAfterLoginUrl(url: string): Promise<void> {
        localStorage.setItem(this.afterLoginName, url)
    }
    async loadAfterLoginUrl(): Promise<string | null> {
        return localStorage.getItem(this.afterLoginName)
    }
    async clearAfterLoginUrl(): Promise<void> {
        localStorage.removeItem(this.afterLoginName)
    }
}